export const sharedStyles = theme => ({
  badgeRoot: {
    paddingRight: 0,
    flexShrink: 0,
  },
  badgeContainer: {
    height: 'auto',
    margin: 0,
    '& span': {
      color: 'inherit',
      paddingTop: 0,
      marginLeft: 15,
      fontSize: 'inherit',
    },
  },
  divider: {
    borderRight: '1px solid #C0BFBF',
    margin: '0 15px',
    height: 22,
  },
  nextButton: {
    padding: '10px 16px',
    borderRadius: 20,
    minWidth: 106,
    border: '1px solid transparent',
    '&:disabled,&:disabled:hover': {
      pointerEvents: 'none',
      backgroundColor: '#E0E0E0',
    },
  },
  customCheckboxContainer: {
    width: 24,
    height: 24,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& div': {
      display: 'inline-flex',
      width: 19,
      height: 19,
      border: '1px solid #E0E0E0',
      borderRadius: 3,
      backgroundColor: '#fff',
      borderColor: theme?.palette.text.primary,
    },
  },
  checkbox: {
    marginRight: 10,
  },
});
